"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createGapVerticalStyles = exports.createGapStyles = exports.createStyles = exports.Grid = exports.GridContext = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("../../styles");
exports.GridContext = react_1.default.createContext(null);
function Grid(props) {
    var style = props.style, wrap = props.wrap, alignItems = props.alignItems, justifyContent = props.justifyContent, direction = props.direction, gap = props.gap, gapVertical = props.gapVertical, rest = __rest(props, ["style", "wrap", "alignItems", "justifyContent", "direction", "gap", "gapVertical"]);
    var _a = styles_1.useStyles(exports.createStyles, props), classes = _a.classes, css = _a.css;
    var gapClasses = styles_1.useStyles(exports.createGapStyles, props).classes;
    var gapVerticalClasses = styles_1.useStyles(exports.createGapVerticalStyles, props).classes;
    var className = css(classes.grid, wrap && classes.wrap, typeof gap === 'object' && [
        gap.xs && gapClasses.xs,
        gap.sm && gapClasses.sm,
        gap.md && gapClasses.md,
        gap.lg && gapClasses.lg,
        gap.xl && gapClasses.xl,
    ], typeof gapVertical === 'object' && [
        gapVertical.xs && gapVerticalClasses.xs,
        gapVertical.sm && gapVerticalClasses.sm,
        gapVertical.md && gapVerticalClasses.md,
        gapVertical.lg && gapVerticalClasses.lg,
        gapVertical.xl && gapVerticalClasses.xl,
    ], style);
    return (react_1.default.createElement(exports.GridContext.Provider, { value: props },
        react_1.default.createElement("div", __assign({ className: className }, rest))));
}
exports.Grid = Grid;
Grid.defaultProps = {
    gap: 2,
    gapVertical: 1,
    wrap: true,
};
exports.createStyles = function (theme, _a) {
    var direction = _a.direction, alignItems = _a.alignItems, justifyContent = _a.justifyContent, gap = _a.gap, gapVertical = _a.gapVertical;
    return ({
        grid: {
            display: 'flex',
            flexDirection: direction,
            alignItems: alignItems,
            justifyContent: justifyContent,
            marginLeft: typeof gap === 'number' && -gap / 2 + "rem",
            marginRight: typeof gap === 'number' && -gap / 2 + "rem",
            marginTop: typeof gapVertical === 'number' && -gapVertical / 2 + "rem",
            marginBottom: typeof gapVertical === 'number' && -gapVertical / 2 + "rem",
        },
        wrap: {
            flexWrap: 'wrap',
        },
    });
};
exports.createGapStyles = function (theme, _a) {
    var _b, _c, _d, _e;
    var gap = _a.gap;
    return ({
        xs: {
            marginLeft: -gap.xs / 2 + "rem",
            marginRight: -gap.xs / 2 + "rem",
        },
        sm: (_b = {},
            _b[theme.breakpoints.up('sm')] = {
                marginLeft: -gap.sm / 2 + "rem",
                marginRight: -gap.sm / 2 + "rem",
            },
            _b),
        md: (_c = {},
            _c[theme.breakpoints.up('md')] = {
                marginLeft: -gap.md / 2 + "rem",
                marginRight: -gap.md / 2 + "rem",
            },
            _c),
        lg: (_d = {},
            _d[theme.breakpoints.up('lg')] = {
                marginLeft: -gap.lg / 2 + "rem",
                marginRight: -gap.lg / 2 + "rem",
            },
            _d),
        xl: (_e = {},
            _e[theme.breakpoints.up('xl')] = {
                marginLeft: -gap.xl / 2 + "rem",
                marginRight: -gap.xl / 2 + "rem",
            },
            _e),
    });
};
exports.createGapVerticalStyles = function (theme, _a) {
    var _b, _c, _d, _e;
    var gapVertical = _a.gapVertical;
    return ({
        xs: {
            marginTop: -gapVertical.xs / 2 + "rem",
            marginBottom: -gapVertical.xs / 2 + "rem",
        },
        sm: (_b = {},
            _b[theme.breakpoints.up('sm')] = {
                marginTop: -gapVertical.sm / 2 + "rem",
                marginBottom: -gapVertical.sm / 2 + "rem",
            },
            _b),
        md: (_c = {},
            _c[theme.breakpoints.up('md')] = {
                marginTop: -gapVertical.md / 2 + "rem",
                marginBottom: -gapVertical.md / 2 + "rem",
            },
            _c),
        lg: (_d = {},
            _d[theme.breakpoints.up('lg')] = {
                marginTop: -gapVertical.lg / 2 + "rem",
                marginBottom: -gapVertical.lg / 2 + "rem",
            },
            _d),
        xl: (_e = {},
            _e[theme.breakpoints.up('xl')] = {
                marginTop: -gapVertical.xl / 2 + "rem",
                marginBottom: -gapVertical.xl / 2 + "rem",
            },
            _e),
    });
};
//# sourceMappingURL=Grid.js.map